// extracted by mini-css-extract-plugin
export default {"userImage":"y8KKAFRTihEAhDFM0Qiw","userImageImage":"IJ9exHEiHe1Qg1rCN6vI"};